import axios from "axios";
import HTTP from "./http";

export default {
    getAllRoles: payload => axios.get(HTTP.GET_ALL_ROLES, payload)
}